import React from "react";
import { categories } from "../data/data";
import { motion } from "framer-motion";

const Category = () => {
  return (
    <div className="max-w-[1640px] m-auto px-4 py-12">
      <motion.h1
        className="text-orange-600 font-bold text-4xl text-center"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        Top Rated Menu Items
      </motion.h1>

      <motion.div
        className="grid grid-cols-2 md:grid-cols-4 gap-6 py-6"
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 0, y: 20 },
          visible: {
            opacity: 1,
            y: 0,
            transition: { staggerChildren: 0.2, duration: 0.5 },
          },
        }}
      >
        {categories.map((item, index) => (
          <motion.div
            key={index}
            className="bg-gray-100 rounded-lg p-4 flex justify-between items-center cursor-pointer"
            whileHover={{ scale: 1.05, rotate: 2 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
          >
            <h2 className="text-lg font-semibold">{item.name}</h2>
            <motion.img
              src={item.image}
              alt={item.name}
              className="w-20"
              whileHover={{ scale: 1.2, rotate: -5 }}
              transition={{ duration: 0.3 }}
            />
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default Category;
